<template>
  <vue-dropzone
    ref="myVueDropzone"
    id="dropzone"
    :options="dropzoneOptions"
    @vdropzone-sending="onArtworkSend"
    @vdropzone-files-added="onArtworkAdded"
    @vdropzone-success="onArtworkSuccess"
  ></vue-dropzone>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { QuestionnaireService } from "../../../services/questionnaire.service";

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: ["checksum", "promoter_id", "clientID", "calendar_date_id"],
  async mounted() {
    const res = await QuestionnaireService.get_flyer_files(
      this.checksum,
      this.promoter_id,
      this.calendar_date_id,
      this.language
    );

    console.log({ res: res });

    if (res?.data?.length > 0) {
      for (let f of res.data) {
        const file = { size: f.filesize, name: f.file_name };
        const url = f.url;
        this.$refs.myVueDropzone.manuallyAddFile(file, url);
        console.log({ file: file });

        file.previewElement.addEventListener("click", (e) => {
          console.log({ f: f, file });
          window.open(f.url, "_blank");
        });
      }
      // const file = { size: 123, name: "Icon", type: "image/png" };
    }
  },
  computed: {
    dropzoneOptions() {
      return {
        url: `https://dev.berlin3.com/promoter/${this.clientID}/${this.checksum}/${this.promoter_id}/calendar_date_id=${this.calendar_date_id}&lang=en&viewtype=original`,
        paramName: "file_name",
        clickable: true,
        thumbnailWidth: 300,
      };
    },
  },
  methods: {
    onArtworkSend(file, xhr, data) {
      console.log({ data: data });
      data.append("action", "add_files");
      data.append("checksum", this.checksum);
      data.append("promoter_id", this.promoter_id);
      data.append("clientID", this.clientID);
      data.append("calendar_date_id", this.calendar_date_id);
    },
    onArtworkAdded(file) {
      console.log("onArtworkAdded", file);
      // file.previewElement.addEventListener("click", function () {});
    },
    onArtworkSuccess(file, response) {
      console.log("onArtworkSuccess", file, response);
      file.previewElement.addEventListener("click", (e) => {
        window.open(response.url, "_blank");
      });
      // file.previewElement.addEventListener("click", function () {});
    },
  },
};
</script>

<style lang="scss">
.dropzone.dz-clickable {
  cursor: pointer;
}
.dropzone.dz-clickable * {
  cursor: pointer;
}
.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}
.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
  cursor: pointer;
}
.dropzone .dz-preview .dz-remove {
  font-size: 14px;
  text-align: center;
  display: block;
  cursor: pointer;
  border: none;
}
.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 1em;
  font-size: 16px;
  cursor: pointer;
}
.dropzone .dz-preview .dz-details .dz-filename {
  white-space: nowrap;
  cursor: pointer;
}
</style>
